const stage = document.querySelector('[data-stage]');

if (stage) {
  const root = document.documentElement;
  const setPhase = () => {
    const max = Math.max(1, stage.offsetHeight - window.innerHeight);
    const rect = stage.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -rect.top / max));
    const phase = progress < 0.34 ? 0 : progress < 0.67 ? 1 : 2;
    root.style.setProperty('--scroll-progress', progress.toFixed(4));
    if (stage.dataset.phase !== String(phase)) {
      stage.dataset.phase = String(phase);
      stage.dispatchEvent(new CustomEvent('gravel:phase', { detail: { phase, progress } }));
    }
  };

  let scheduled = false;
  const requestUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      setPhase();
    });
  };

  addEventListener('scroll', requestUpdate, { passive: true });
  addEventListener('resize', requestUpdate);
  setPhase();
}
